export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/gi
export const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/g
export const URLRegex = /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi

export const isValidEmail = (input: string): boolean => !!input.match(emailRegex)
export const isValidPhone = (input: string): boolean => !!input.match(phoneRegex)
export const isValidURL = (input: string): boolean => !!input.match(URLRegex)
